import clsx from 'clsx';

import SearchBar from '~/shared/components/SearchBar';
import { buildSearchInputId } from '~/shared/components/searchInputMeta';

interface SearchAccountProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  placeholder?: string;
  className?: string;
}

export default function SearchAccount({
  searchTerm,
  onSearchChange,
  placeholder = 'Search Organization/account',
  className,
}: SearchAccountProps) {
  return (
    <div>
      <SearchBar
        inputId={buildSearchInputId('app', 'account-switcher')}
        aria-label="Search accounts"
        placeholder={placeholder}
        size="sm"
        className={clsx('w-full h-12', className)}
        value={searchTerm} // Controlled component
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value)}
      />
    </div>
  );
}
